module.exports = __webpack_public_path__ + "static/media/Military-Nurse_main_t.b4925c53.jpg";